// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BarAboveTitle_wrapper__Atevl","tags":"BarAboveTitle_tags__OMH_M","tag":"BarAboveTitle_tag__ePWEH"};